"use strict";

exports.__esModule = true;
exports.isWeeklyTimetable = exports.isServicePage = exports.isServiceListWidget = exports.isServiceListPage = exports.isDailyAgenda = exports.isCalendarWidget = exports.isCalendarPage = exports.WidgetName = void 0;
let WidgetName = exports.WidgetName = /*#__PURE__*/function (WidgetName) {
  WidgetName["CALENDAR_WIDGET"] = "CALENDAR_WIDGET";
  WidgetName["CALENDAR_PAGE"] = "CALENDAR_PAGE";
  WidgetName["SERVICE_LIST_WIDGET"] = "SERVICE_LIST_WIDGET";
  WidgetName["SERVICE_LIST_PAGE"] = "SERVICE_LIST_PAGE";
  WidgetName["SERVICE_PAGE"] = "SERVICE_PAGE";
  WidgetName["WEEKLY_TIMETABLE"] = "WEEKLY_TIMETABLE";
  WidgetName["DAILY_AGENDA"] = "DAILY_AGENDA";
  return WidgetName;
}({});
const isCalendarWidget = widgetName => widgetName === WidgetName.CALENDAR_WIDGET;
exports.isCalendarWidget = isCalendarWidget;
const isCalendarPage = widgetName => widgetName === WidgetName.CALENDAR_PAGE;
exports.isCalendarPage = isCalendarPage;
const isServiceListWidget = widgetName => widgetName === WidgetName.SERVICE_LIST_WIDGET;
exports.isServiceListWidget = isServiceListWidget;
const isServiceListPage = widgetName => widgetName === WidgetName.SERVICE_LIST_PAGE;
exports.isServiceListPage = isServiceListPage;
const isServicePage = widgetName => widgetName === WidgetName.SERVICE_PAGE;
exports.isServicePage = isServicePage;
const isWeeklyTimetable = widgetName => widgetName === WidgetName.WEEKLY_TIMETABLE;
exports.isWeeklyTimetable = isWeeklyTimetable;
const isDailyAgenda = widgetName => widgetName === WidgetName.DAILY_AGENDA;
exports.isDailyAgenda = isDailyAgenda;
//# sourceMappingURL=widgetName.js.map